import { InvoicesColumns } from "@portal/BaseComponents/Table/Components/Invoices/InvoicesColumn";
import { Formats } from "@portal/hooks/use-formats";
import { CreditMemo } from "@portal/types/entities/credit-memo";
import { GridColumnProps } from "@sinecycle/growcomponents";
import { sum } from "lodash";
import { useMemo } from "react";
import { ReferenceCell } from "./Reference/ReferenceCell";

function useColumns(extra: Formats) {
  function handleColumns() {
    const columns: GridColumnProps<CreditMemo> = [
      {
        colId: "Reference",
        headerName: "Reference #",
        cellRenderer: ReferenceCell,
        pinned: "left",
      },
      {
        colId: "Credit_Date",
        headerName: "Credit Date",
        field: "date",
        cellRenderer: "dateCell",
        cellRendererParams: {
          dateCellProps: {
            format: extra.dateformat,
          },
        },
      },
      {
        colId: "Notes",
        headerName: "Notes",
        field: "note",
        cellRenderer: "textCell",
        cellRendererParams: {
          textCellProps: {
            ellipsis: {
              tooltip: {
                placement: "top",
              },
            },
          },
        },
      },
      {
        colId: "Total_Amount",
        headerName: "Total Amount",
        field: "amount",
        cellRenderer: "amountCell",
        cellRendererParams: {
          amountTextProps: {
            textProps: {
              strong: true,
            },
            locale: extra.locale,
          },
        },
        valueGetter: (params) => {
          return {
            amount: params.data?.amount,
            currency: params.data?.currency,
          };
        },
      },
      {
        colId: "Invoice",
        headerName: "Associated Invoice(s)",
        cellRenderer: "invoices",
        field: "invoices",
        flex: 1,
        valueGetter: (params) => {
          function getInvoices(): InvoicesColumns[] {
            if (!params.data) return [];
            return params.data.invoices.map((invoice) => {
              return {
                id: invoice.id,
                title: invoice.number,
                amount: sum(
                  params?.data?.invoice_credit_memos[invoice.id].map(
                    (memo) => memo.amount
                  )
                ),
                currency: invoice.currency,
              };
            });
          }
          return getInvoices();
        },
      },
    ];
    return columns;
  }

  const defaultColConfigs = useMemo(handleColumns, [
    extra.dateformat,
    extra.locale,
  ]);

  return { defaultColConfigs };
}

export { useColumns };
